import { RemoveSingleClassOfBusiness, RemoveSingleClassOfBusinessVariables } from "_graphql/mutation/__generated__/RemoveSingleClassOfBusiness";

import { LocationGenerics } from "router/location";
import { PopUp } from "components";
import { removeClassOfBusiness } from "_graphql/visal/mutations/class-of-business";
import toast from "react-hot-toast";
import { useMutation } from "@apollo/client";
import { useSearch } from "react-location";

export default function RemoveContainer({
    open,
    setOpen,
    refetch,
}: {
    open: boolean;
    setOpen: (val: boolean) => void;
    refetch?: () => void;
}) {
    const searchParams = useSearch<LocationGenerics>()
    const [remove, { loading }] = useMutation<RemoveSingleClassOfBusiness, RemoveSingleClassOfBusinessVariables>(removeClassOfBusiness, {
        refetchQueries: ["ClassOfBusinesses"]
    });


    const handleSubmit = async () => {
        await remove({
            variables: {
                classOfBusinessId: searchParams?.id || ""
            },
        }).then(({ data }) => {
            if (data?.removeSingleClassOfBusiness) {
                toast.success("Class of Business Removed Successfully");
                refetch?.();
                setOpen?.(false);
            } else {
                toast.error("Failed to remove Class of Business");
            }
        });
    }

    return (
        <PopUp
            open={open}
            setOpen={setOpen}
            title="Remove Class of Business"
            cancelText="No, Don't Remove Class of Business"
            description="This action would completely remove business details from system"
            renderActions={() => (
                <>
                    <button
                        type="button"
                        disabled={loading}
                        className="w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 bg-red-600 text-base font-medium text-white hover:bg-red-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500 sm:ml-3 sm:w-auto sm:text-sm"
                        onClick={handleSubmit}
                    >
                        {loading ? "Removing Class of Business..." : "Remove Class of Business"}
                    </button>
                </>
            )}
        />
    );
}
